/*
 * @Author: wsx
 * @Date: 2022-01-12 10:33:01
 * @LastEditTime: 2022-01-12 10:41:05
 * @LastEditors: your name
 * @Description: Layout
 */
const state = {
  paths: []
};

const mutations = {
  setPaths(state, data) {
    console.log(
      "%c [ data ]-14",
      "font-size:13px; background:pink; color:#bf2c9f;",
      data
    );
    state.paths = data;
  }
};
const actions = {};
export default {
  state: () => state,
  mutations,
  actions
};
